var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _VideoManager_disabled, _VideoManager_observer, _VideoManager_videos, _VideoManager_playbackQueue, _VideoManager_onStatusChange;
class VideoManager {
    constructor() {
        _VideoManager_disabled.set(this, void 0);
        _VideoManager_observer.set(this, void 0);
        _VideoManager_videos.set(this, []);
        _VideoManager_playbackQueue.set(this, new Set());
        _VideoManager_onStatusChange.set(this, void 0);
        __classPrivateFieldSet(this, _VideoManager_disabled, !this.isIntersectionObserverAvailable(), "f");
        if (__classPrivateFieldGet(this, _VideoManager_disabled, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _VideoManager_observer, new IntersectionObserver(this.onIntersect.bind(this), { threshold: [0, 1] }), "f");
        __classPrivateFieldSet(this, _VideoManager_onStatusChange, this.processQueue.bind(this), "f");
    }
    add(video) {
        if (__classPrivateFieldGet(this, _VideoManager_disabled, "f")) {
            return;
        }
        __classPrivateFieldGet(this, _VideoManager_videos, "f").push(video);
        __classPrivateFieldGet(this, _VideoManager_observer, "f").observe(video.cover);
    }
    remove(video) {
        if (__classPrivateFieldGet(this, _VideoManager_disabled, "f")) {
            return;
        }
        const index = __classPrivateFieldGet(this, _VideoManager_videos, "f").indexOf(video);
        if (index === -1) {
            return;
        }
        __classPrivateFieldGet(this, _VideoManager_observer, "f").unobserve(video.cover);
        __classPrivateFieldGet(this, _VideoManager_videos, "f").splice(index, 1);
        this.dequeueVideo(video);
    }
    processQueue() {
        let mayNeedReorder = false;
        loop: for (const video of __classPrivateFieldGet(this, _VideoManager_playbackQueue, "f")) {
            switch (video.status) {
                case 'locked':
                    mayNeedReorder = true;
                    continue;
                case 'error':
                case 'done':
                    this.dequeueVideo(video);
                    continue;
                case 'init':
                    video.preload();
                    break loop;
                case 'playing':
                case 'waiting':
                case 'loading':
                    break loop;
                case 'ready':
                    video.wait();
                    break loop;
                case 'waited':
                    video.play();
                    break loop;
            }
        }
        // move locked to the end
        if (mayNeedReorder) {
            this.reorderQueue();
        }
    }
    enqueueVideo(video) {
        if (__classPrivateFieldGet(this, _VideoManager_playbackQueue, "f").has(video)) {
            return;
        }
        __classPrivateFieldGet(this, _VideoManager_playbackQueue, "f").add(video);
        video.addListener(__classPrivateFieldGet(this, _VideoManager_onStatusChange, "f"));
    }
    dequeueVideo(video) {
        if (!__classPrivateFieldGet(this, _VideoManager_playbackQueue, "f").has(video)) {
            return;
        }
        __classPrivateFieldGet(this, _VideoManager_playbackQueue, "f").delete(video);
        video.removeListener(__classPrivateFieldGet(this, _VideoManager_onStatusChange, "f"));
    }
    onIntersect(entries) {
        const newVideos = [];
        for (const entry of entries) {
            const video = this.getVideoByCover(entry.target);
            if (!video) {
                continue;
            }
            if (entry.intersectionRatio === 0) {
                this.dequeueVideo(video);
                video.hide();
            }
            else if (entry.intersectionRatio === 1) {
                newVideos.push(video);
            }
        }
        newVideos.sort(() => Math.random() - 0.5).forEach(video => this.enqueueVideo(video));
        this.processQueue();
    }
    getVideoByCover(cover) {
        for (const video of __classPrivateFieldGet(this, _VideoManager_videos, "f")) {
            if (cover === video.cover) {
                return video;
            }
        }
        return null;
    }
    isIntersectionObserverAvailable() {
        return 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    }
    reorderQueue() {
        const locked = new Set();
        const unlocked = new Set();
        let valid = true;
        for (const video of __classPrivateFieldGet(this, _VideoManager_playbackQueue, "f")) {
            if (video.status === 'locked') {
                locked.add(video);
                continue;
            }
            unlocked.add(video);
            if (locked.size) {
                valid = false;
            }
        }
        if (valid) {
            return;
        }
        __classPrivateFieldSet(this, _VideoManager_playbackQueue, new Set([...unlocked, ...locked]), "f");
    }
}
_VideoManager_disabled = new WeakMap(), _VideoManager_observer = new WeakMap(), _VideoManager_videos = new WeakMap(), _VideoManager_playbackQueue = new WeakMap(), _VideoManager_onStatusChange = new WeakMap();
export default VideoManager;
